module.exports = __webpack_public_path__ + "static/media/LevelUp.0d3a04ec.webp";